export default __webpack_public_path__ + "static/media/IMG_20191001_122946.9f6a842d.jpg";